import gql from 'graphql-tag';

export const WorkflowFragment = gql`
  fragment WorkflowInfo on Workflow {
    id
    serialNo
    workflowType
    currentStep
    playerId
    paymentTypeId
    playerBankAccountId
    companyBankAccountId
    remark
    paymentGatewayId
    paymentGatewayProviderCode
    receiptUrl
    receiptDate
    receiptReferenceNo
    intermediateWalletId
    fromKioskAccountId
    toKioskAccountId
    errorMessage
    completedAt
    isActive
    isArchived
    createdAt
    updatedAt
    createdBy
    updatedBy
    currentStepTransaction {
      id
      transactionType
      transactionStatus
      kioskStatus
    }
  }
`;
